/**
 * A wallet answered a signature request with an error instead of a signature
 * (and the user did NOT cancel: that is `isUserRejection`).
 *
 * Why it needs its own class: the raw text is the wallet's (a hardware wallet
 * refusing typed data without blind signing, an extension on the wrong
 * network refusing the domain, a mobile wallet that does not support the
 * method), so nothing about it says "our side". Without the tag the presenter
 * could only show its generic fallback, which on 2026-09-04 turned a
 * wallet-side failure at the sign-in prompt into "something went wrong on our
 * side" with no lead for support. The cause is kept for the console.
 */
export class WalletSignatureError extends Error {
    readonly name = 'WalletSignatureError';

    constructor(readonly cause: unknown) {
        super('The wallet returned an error instead of a signature.');
    }
}

export function isWalletSignatureError(
    error: unknown,
): error is WalletSignatureError {
    return error instanceof WalletSignatureError;
}
